import * as types from "../mutation-types";

export const state = {
  error: null,
};

export const getters = {
  message: (state) => state.error,
};

export const mutations = {
  [types.ERROR_SET](state, error) {
    state.error = error;
  },
};

export const actions = {
  async handle({ commit }, error) {
    let message = null;

    switch (error.reason) {
      case "invalid_id_token":
      case "no_auth_token":
      case "invalid_signature":
      case "decode_error":
        message = "Something went wrong. Please try to login again.";
        break;
      case "no_customer":
        message = "Customer does not exist";
        break;
      case "invalid_body":
        message =
          "Invalid request body. Please contact Online Partner for further assistance";
        break;
      case "validation_error":
        message =
          "A validation error occurred. Please fill out the form correctly.";
        break;
      case "invalid_api_call":
        message =
          "Backend error. Please contact Online Partner for further assistance.";
        break;
      case "not_admin":
        message = "You are not an admin.";
        break;
      case "no_group":
        message = "That group does not exist.";
        break;
      case "not_in_group":
        message = "You are not in that group.";
        break;
    }

    if (error.message) {
      message = error.message;
    }

    commit(types.ERROR_SET, message);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
